/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactResponse } from '../../models/contact-response';

export interface GetContact$Params {
  id: number;
}

export function getContact(http: HttpClient, rootUrl: string, params: GetContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactResponse>> {
  const rb = new RequestBuilder(rootUrl, getContact.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactResponse>;
    })
  );
}

getContact.PATH = '/contacts/{id}';
